import script from "./GradeScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./GradeScreen.vue?vue&type=script&setup=true&lang=ts"

import "./GradeScreen.vue?vue&type=style&index=0&id=3e0e64e0&lang=scss"

const __exports__ = script;

export default __exports__